import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { GroupedServices } from '../../interfaces';

@Component({
  selector: 'fin-grouped-services',
  templateUrl: 'grouped-services.component.html',
  styleUrls: ['../../assets/helper-classes.scss', 'grouped-services.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupedServicesComponent {
  @Input()
  groupedServices: GroupedServices[];
}
